import { portalApi } from "./client";
import type { TaxForm } from "./tpsTaxForms";

// TPS Servicing Portal PR-I (WS4) — portal-side client for the recipient
// self-service "Tax forms" tab, shared by ALL four recipient portals (buyer /
// seller / broker / vendor). NOT tps-scoped: any authenticated portal account
// sees its OWN Sent forms, matched on the RecipientPortalUserId stamped at send.
// Mirrors the C# records the backend exposes under /api/portal/tax-forms. No
// React Query in the portal — callers load with useState.
//
// The recipient sees the SAME Form1099ReportDto the TPS does (masked TIN only —
// the reveal path is TPS/staff-owned), so the row type is reused.
export type { TaxForm } from "./tpsTaxForms";

export const taxFormsApi = {
  /** The caller's own Sent forms across every recipient account type. */
  list: () => portalApi.get<TaxForm[]>("/tax-forms"),
  /** The caller's own form PDF (404 unless it was sent to them) as a Blob. */
  pdf: (id: string) => portalApi.getBlob(`/tax-forms/${id}/pdf`),
};
